export default __webpack_public_path__ + "static/media/logo_boottom.86874a04.png";